import { BaseTestimonial } from "./BaseTestimonial";

export class TestimonialModel extends BaseTestimonial {
    constructor(data) {
        super(data);
    }
}
